module.exports = __webpack_public_path__ + "static/media/dxJy.0c939c5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dxJy.png
// module id = 1749
// module chunks = 0 1